import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DetalharBoleto.module.css';

function DetalharBoleto() {
    const { id } = useParams();
    const [boleto, setBoleto] = useState(null);
    const BASE_URL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        const fetchBoleto = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${BASE_URL}/hello-sol/boletos/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setBoleto(data);
                } else {
                    throw new Error('Erro ao buscar boleto.');
                }
            } catch (error) {
                console.error('Erro ao fazer a requisição:', error.message);
            }
        };
        fetchBoleto();
    }, [id, BASE_URL]);

    const acessarBoleto = () => {
        if (boleto?.invoiceUrl) {
            window.open(boleto.invoiceUrl, '_blank');
        }
    };

    if (!boleto) {
        return <div>Carregando...</div>;
    }

    return (
        <div className={styles.container}>
            <h2>Detalhar Boleto</h2>
            <form>
                <div className={styles.row}>
                    <div className={styles.field}>
                        <label htmlFor="vlBoleto">Valor do Boleto</label>
                        <input
                            name="valorBoleto"
                            value={boleto.value}
                            placeholder="Quantidade KWh Consumido"
                            disabled
                        />
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="statusBoleto">Situação do Boleto</label>
                        <input
                            name="situacaoBoleto"
                            value={boleto.status}
                            placeholder="Situação do Boleto"
                            disabled
                        />
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="dataVencimento">Data Vencimento</label>
                        <DatePicker
                            selected={new Date(boleto.dueDate)}
                            dateFormat="dd/MM/yyyy"
                            calendarClassName={styles.datePicker}
                            disabled
                        />
                    </div>
                </div>
                <button type="button" onClick={acessarBoleto} className={styles.button}>
                    Acessar Boleto
                </button>
            </form>
        </div>
    );
}

export default DetalharBoleto;
